import type { Day } from "./types";

// Indy Brand Colors
export const COLORS = {
  orange: "#f9563a",
  navy: "#172939",
  navyLight: "#1e3a4f",
  navyDark: "#0f1c26",
  white: "#FFFFFF",
  white70: "rgba(255, 255, 255, 0.7)",
  white50: "rgba(255, 255, 255, 0.5)",
  white20: "rgba(255, 255, 255, 0.2)",
  white10: "rgba(255, 255, 255, 0.1)",
};

// Day definitions for the weekly grid
export const DAYS: Day[] = [
  { key: "mon", label: "Monday", short: "Mon", letter: "M" },
  { key: "tue", label: "Tuesday", short: "Tue", letter: "T" },
  { key: "wed", label: "Wednesday", short: "Wed", letter: "W" },
  { key: "thu", label: "Thursday", short: "Thu", letter: "T" },
  { key: "fri", label: "Friday", short: "Fri", letter: "F" },
  { key: "sat", label: "Saturday", short: "Sat", letter: "S" },
  { key: "sun", label: "Sunday", short: "Sun", letter: "S" },
];

// Hour markers for the grid (every 2 hours)
export const HOUR_MARKERS = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];

// Grid snap interval in minutes (drag/resize snaps to this)
export const SNAP_INTERVAL_MINUTES = 30;

// Minimum block height as percentage (so tiny blocks are still visible)
export const MIN_BLOCK_HEIGHT_PERCENT = 2;

// Minimum schedule duration in minutes
export const MIN_DURATION_MINUTES = 30;

// Total minutes in a day
export const MINUTES_PER_DAY = 1440;

// Fixed height for the schedule grid (in pixels)
// This makes the grid compact while still being usable for hourly scheduling
export const GRID_HEIGHT_PX = 400;

// Row height for each day in the horizontal layout (in pixels)
export const DAY_ROW_HEIGHT_PX = 80;
